import { BookingFor } from './BookingFor'

export interface ContactFormFields {
  firstName: string
  lastName: string
  phone: string
  email: string
  consent: boolean
  dentalTosAccepted: boolean
  gender: string
  bookingFor?: BookingFor
  patient_child?: boolean
  patient_gender?: string
  patient_firstName?: string
  patient_lastName?: string
  insurance_holder?: InsuranceHolder
  reasonForVisit?: string
  birthdate: string
  patient_birthdate: string
}

export type FieldChange = {
  field: string
  value: any
}

export enum InsuranceHolder {
  Patient = 'PATIENT',
  Contact = 'CONTACT_PERSON',
}
